<!--
  vivest-modal (design system): título no atributo heading; lista no slot "description" (o modal
  não tem slot de conteúdo livre); botões no slot "actions". Mesmo formato do "Adicionar documentos".
-->
<vivest-modal
  [attr.heading]="editando() ? 'Editar situação cadastral' : 'Adicionar situação cadastral'"
  [hasIcon]="false"
  open
  dismissible
  (vivest-close)="fechar.emit()"
  data-testid="situacoes-modal"
>
  <div slot="description" class="situacoes-modal">
    <p class="situacoes-modal__descricao">{{ descricao() }}</p>

    <ul class="situacoes-modal__itens">
      @for (opcao of opcoes(); track opcao.value) {
        <li class="situacoes-modal__item">
          <vivest-checkbox
            class="situacoes-modal__opcao"
            label-variant="multi-line"
            name="situacoes-cadastrais-disponiveis"
            [value]="opcao.value"
            [checked]="jaIncluida(opcao.value) || selecionadas().has(opcao.value)"
            [disabled]="jaIncluida(opcao.value)"
            (change)="alternar(opcao.value)"
            [attr.data-testid]="'situacoes-modal-opcao-' + opcao.value"
          >
            {{ opcao.label }}
          </vivest-checkbox>
          @if (jaIncluida(opcao.value)) {
            <span class="situacoes-modal__tag">Já incluída</span>
          }
        </li>
      }
    </ul>
  </div>

  <vivest-button slot="actions" variant="outline" size="md" data-testid="situacoes-modal-cancelar" (click)="fechar.emit()">
    Cancelar
  </vivest-button>
  <vivest-button
    slot="actions"
    variant="primary"
    size="md"
    [disabled]="totalSelecionado() === 0"
    data-testid="situacoes-modal-adicionar"
    (click)="confirmar()"
  >
    @if (devolveListaInteira()) {
      Salvar
    } @else {
      {{ totalSelecionado() > 0 ? 'Adicionar (' + totalSelecionado() + ')' : 'Adicionar' }}
    }
  </vivest-button>
</vivest-modal>
